






























































































import { FundingSource } from "@/types/Payments"
import { Vue, Component } from "vue-property-decorator"
import RetryVerificationDialog from "./RetryVerificationDialog.vue"
import DocumentUploadDialog from "./DocumentUploadDialog.vue"
import AddFundingSourceDialog from "./AddFundingSourceDialog.vue"
import VerifyFundingSourceDialog from "./VerifyFundingSourceDialog.vue"
import EditFundingSourceDialog from "./EditFundingSourceDialog.vue"
import RemoveFundingSourceDialog from "./RemoveFundingSourceDialog.vue"
import BeneficialOwnersDialog from "./BeneficialOwnersDialog.vue"
import ClipboardCopy from '@/components/ClipboardCopy.vue'
import { loadFundingSources } from "@/services/payments"
import { currentUserIs, Managers, UserRole } from "@/types/Users"
import { dwollaCustomerIdFromUrl, dwollaFundingSourceIdFromUrl } from "@/util/dwolla"

@Component({
	components: {
    RetryVerificationDialog,
    DocumentUploadDialog,
    AddFundingSourceDialog,
    VerifyFundingSourceDialog,
    EditFundingSourceDialog,
    RemoveFundingSourceDialog,
    BeneficialOwnersDialog,
    ClipboardCopy,
	},
  metaInfo: {
    title: 'Settings - Payments'
  }
})
export default class Payments extends Vue {


  loadingFundingSources = false
  loadingNewFundingSource = false
	selectedFundingSource: any = null
	
  retryVerificationDialog = false
  documentUploadDialog = false

  addFundingSourceDialog = false
	editFundingSourceDialog = false
  verifyFundingSourceDialog = false
	removeFundingSourceDialog = false
	beneficialOwnersDialog = false

  verificationStatuses: {
    [key: string]: {
      color: string
      text: string
    }
  } = {
    verified: {
      color: 'success',
      text: 'Verified',
    },
    unverified: {
      color: 'warning',
      text: 'Unverified',
    },
    retry: {
      color: 'warning',
      text: 'Verification needed',
    },
    document: {
      color: 'blue',
      text: 'Document upload needed',
    },
    suspended: {
      color: 'error',
      text: 'Suspended',
    },
    deactivated: {
      color: 'grey',
      text: 'Deactivated',
    },
  }

  mounted() {
    if (this.$route.params.verifyBeneficialOwners == "true") {
      this.beneficialOwnersDialog = true
    }
    if (this.$route.params.addFundingSource == "true") {
      this.addFundingSourceDialog = true
    }
    if (this.$route.params.verifyIdentity == "true") {
      this.openVerifyDialog()
    }

    this.loadFundingSources()
  }
  
  get me() {
    return this.$store.getters.me
  }

	get fundingSources() {
		return this.$store.getters.fundingSources
	}

  get showBeneficialOwnersForm() {
    return currentUserIs(UserRole.Admin) &&
      !this.loadingFundingSources && 
      !this.$store.state.payments.beneficialOwnersCertified
  }

  get verificationStatus() {
    const field = this.userIsManager ? 'organization_info' : (this.userIsContractor ? 'contractor_info' : null)
    if (!field) return null
    const status = this.me[field].dwolla_customer_status
    return status ? {
      ...this.verificationStatuses[status],
      status
    } : null
  }
  
  get userIsManager() {
    return currentUserIs(...Managers)
  }

  get userIsContractor() {
    return currentUserIs(UserRole.Contractor)
  }

  openVerifyDialog() {
    if (!this.verificationStatus) return
    switch (this.verificationStatus.status) {
      case 'retry':
        this.retryVerificationDialog = true
        break
      case 'document':
        this.documentUploadDialog = true
        break
      case 'suspended':
        this.$router.push({ name: 'contact', params: {
          option: 'support',
          description: 'My account has been suspended.\n',
        }})
        break
    }
  }

  customerId(customerUrl: string) {
    return dwollaCustomerIdFromUrl(customerUrl)
  }

	async loadFundingSources() {
		this.loadingFundingSources = true
		try {
			await loadFundingSources(this.$store)
		} finally {
			this.loadingFundingSources = false
		}
	}

  verifyFundingSource(fundingSource: FundingSource) {
		this.selectedFundingSource = fundingSource
		this.verifyFundingSourceDialog = true
  }

	editFundingSource(fundingSource: FundingSource) {
		this.selectedFundingSource = fundingSource
		this.editFundingSourceDialog = true
	}

	removeFundingSource(fundingSource: FundingSource) {
		this.selectedFundingSource = fundingSource
		this.removeFundingSourceDialog = true
	}

	fundingSourceId(fundingSourceUrl: string) {
		return dwollaFundingSourceIdFromUrl(fundingSourceUrl)
	}
}
